export default __webpack_public_path__ + "static/media/nexity-white-logo.7ed2bae3.svg";